/*****
 * Created by Allan on 2022/08/05.
 * Contact 84880528@qq.com.
 * *****/
import store from '@/repayment/store/'
import router from '@/repayment/router/'

/*****
 * 处理 http 成功状态
 * @param  axios response 对象
 * @return 成功状态下返回data 数据，如果包含错误信息，则将后台返回的完整的错误信息 reject 出去。{code:'401', message:'这是一个错误', errors:[] }.
 * *****/
const successHandler = response =>{
    let code = response.data.code;
    if(code==='000000'){
        return Promise.resolve(response.data);
    }else{
        store.dispatch('actionUserSignout');
        return Promise.reject(response.data);
    }
};

/*****
 * 处理http 失败状态
 * @param  axios error ,处理不同错误时的错误消息，确保返回出去为统一的格式。方便处理
 * @return 将完整的错误信息 reject 出去 {code:'401', message:'这是一个错误', errors:[] }
 * *****/
const errHandler = (error) => {
    console.error(`%c接口请求失败 ==>${error.response?error.response.config.url:''}\n`,"color:red",error.response || error);
    // 浏览器返回的错误在 error.response 里面获取，服务器返回的提示信息 直接包含在 error 里面。
    return Promise.reject(error);
};
export  { successHandler, errHandler };



// WEBPACK FOOTER //
// ./src/repayment/services/http/config.js